import { Button, BUTTON_TYPES } from '../../../components/Button'
import { BTN_TXT } from '../../../constants'
import Popup from '../../../components/Popup/Popup'
import { Typography, TYPOGRAPHY_WEIGHT } from '../../../components/Typography'
import Radio, { RadioChangeEvent } from 'antd/lib/radio'
import cn from 'classnames'
import { Space } from 'antd'
import { Fragment, useEffect, useState } from 'react'
import useRouter from '../../../hooks/useRouter'
import { routes } from '../../../router'
import { TPropsCreateRfpModal } from './types'

const CreateRfpModal = ({
  isOpen,
  setIsOpen,
  options
}: TPropsCreateRfpModal) => {
  const { push } = useRouter()
  const [value, setValue] = useState(options[0]?.value)

  useEffect(() => {
    if (isOpen && options[0]) {
      setValue(options[0].value)
    }
  }, [isOpen, options])

  const onCancel = () => {
    setIsOpen(false)
    setValue(options[0]?.value)
  }

  const onChange = (e: RadioChangeEvent) => {
    setValue(e.target.value)
  }

  const onSend = () => {
    push(`${routes.bidding}/rfp/new?typeCreation=${value}`)
  }
  return (
    <>
      <Popup
        visible={isOpen}
        onCancel={onCancel}
        title={'RFP type '}
        width={453}
        className="run-new-step-modal"
        footer={
          <>
            <Button onClick={onCancel} type={BUTTON_TYPES.DEFAULT} upperCase>
              {BTN_TXT.CANCEL}
            </Button>
            <Button type={BUTTON_TYPES.PRIMARY} upperCase onClick={onSend}>
              {BTN_TXT.CONTINUE}
            </Button>
          </>
        }
      >
        <Typography.Body1 weight={TYPOGRAPHY_WEIGHT.NORMAL}>
          To create a RFP, please select RFP type:
          <Radio.Group
            onChange={onChange}
            value={value}
            className={cn('radio-group-default', 'mt-16')}
          >
            <Space direction="vertical">
              <>
                {options.map((i) => (
                  <Fragment key={i.value}>
                    <Radio value={i.value}>
                      <Typography.Body1 weight={TYPOGRAPHY_WEIGHT.NORMAL}>
                        {i.label}
                      </Typography.Body1>
                    </Radio>
                    {i.value === 'health_system' ? (
                      <Typography.Caption className="run-new-step-option__message">
                        RFP and contracts can be used by the selected Health
                        System only
                      </Typography.Caption>
                    ) : null}
                    {i.value === 'community' ? (
                      <Typography.Caption className="run-new-step-option__message">
                        RFP and contracts can be shared with other Health
                        Systems inside Community
                      </Typography.Caption>
                    ) : null}
                  </Fragment>
                ))}
              </>
            </Space>
          </Radio.Group>
        </Typography.Body1>
      </Popup>
    </>
  )
}

export default CreateRfpModal
